import { FormLabel, Typography, MenuItem } from "@mui/material";
import { FC, useRef, useState, useEffect, useMemo, KeyboardEvent, ChangeEvent } from 'react';
import throttle from 'lodash/throttle';
import { getPlacesApiUrl } from '../../services/googlePlaces';
import Select, { StylesConfig } from 'react-select';
import { makeStyles } from "@mui/styles";
import { cardTokens } from '../../styles/commonCards';
import FieldErrorTooltip from '../../components/FormInput/FieldErrorTooltip';
import uploadImageWatermark from '../../images/uploadImageWatermark.png';
const useStyles = makeStyles({
    radios: {
        paddingTop: '0.5rem',
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '-5px',
        marginLeft: '-5px',
        marginRight: '-5px',
        '& > div': {
            fontFamily: 'CircularRegular',
            fontSize: '12px',
            lineHeight: '30px',
            borderRadius: '6px',
            backgroundColor: 'rgb(243, 243, 243)',
            flexWrap: 'wrap',
            color: 'darkgray',
            flex: '1 0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '25%',
            margin: '5px',
            padding: '4px 8px',
            boxSizing: 'border-box',
            textAlign: 'center',
            cursor: 'pointer'
        },
        '& > div.active': {
            backgroundColor: '#94004A',
            color: 'white'
        }
    },
    AppsRadios: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '-5px',
        marginLeft: '-5px',
        marginRight: '-5px',
        '& > div': {
            fontFamily: 'CircularRegular',
            fontSize: '13px',
            borderRadius: '6px',
            backgroundColor: '#E7ECEF',
            flexWrap: 'wrap',
            color: 'rgba(0, 0, 0, 0.87)',
            flex: '1 0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '25%',
            height: '58px',
            margin: '5px',
            padding: '4px 8px',
            boxSizing: 'border-box',
            textAlign: 'center',
            cursor: 'pointer',
            '&:hover': {
                background: cardTokens.infoBackground
            }
        },
        '& > div.active': {
            backgroundColor: '#94004A',
            color: 'white',
            '&:hover': {
            backgroundColor: '#94004A'
            }
        }
    },
    applicationRadios: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '-5px',
        marginLeft: '-5px',
        marginRight: '-5px',
        '& > div': {
            fontFamily: 'CircularRegular',
            fontSize: '13px',
            borderRadius: '6px',
            backgroundColor: '#E7ECEF',
            flexWrap: 'wrap',
            color: 'rgba(0, 0, 0, 0.87)',
            flex: '1 0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '25%',
            height: '45px',
            margin: '5px',
            padding: '4px 8px',
            boxSizing: 'border-box',
            textAlign: 'center',
            cursor: 'pointer',
            '&:hover': {
                background: cardTokens.infoBackground
            }
        },
        '& > div.active': {
            backgroundColor: '#94004A',
            color: 'white',
            '&:hover': {
                backgroundColor: '#94004A'
            }
        }
    },
    helperText: {
        color: '#0000008a',
        fontFamily: 'Arial',
        fontSize: '0.75rem'
    },
    tagInput: {
        border: '1px solid #E7ECEF',
        borderRadius: '8px',
        backgroundColor: '#E7ECEF',
        minHeight: '40px',
        padding: '6px 10px',
        display: 'flex',
        flexWrap: 'wrap' as const,
        gap: '6px',
        alignItems: 'center',
        cursor: 'text',
        '& input': {
            border: 'none',
            background: 'transparent',
            outline: 'none',
            fontFamily: 'CircularRegular',
            fontSize: '13px',
            minWidth: '120px',
            flex: '1',
            height: '28px',
            padding: '0 2px',
        }
    },
    tag: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '2px 8px 2px 10px',
        fontFamily: 'CircularRegular',
        fontSize: '13px',
        '& button': {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0',
            lineHeight: '1',
            color: '#666',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            '&:hover': { color: '#333' }
        }
    },
    tagSuggestions: {
        position: 'absolute',
        zIndex: 1300,
        backgroundColor: '#fff',
        border: '1px solid rgb(232, 232, 232)',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        width: '100%',
        maxHeight: '200px',
        overflowY: 'auto' as const,
        marginTop: '4px'
    },
    tagSuggestionItem: {
        padding: '10px 14px',
        fontFamily: 'CircularRegular',
        fontSize: '13px',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F3F3F3' }
    },
    inputIcon: {
        position: 'absolute',
        color: '#A9B0B5',
        top: '12px',
        right: '20px'
    },
    input: {
        // e4e0e0 disabled
        position: 'relative',
        '& label': {
            display: 'inline-block',
            paddingBottom: '0.5rem',
            fontSize: '10px',
            fontWeight: '600',
            color: '#E2EBFD'
        },
        '&:disabled': {
            backgroundColor: '#e4e0e0'
        },
        '& input': {
            padding: '0 5px',
            height: '30px',
            boxSizing: 'border-box',
            border: '1px solid rgb(232, 232, 232)',
            borderRadius: '6px',
            backgroundColor: 'rgb(243, 243, 243)',
            fontFamily: 'CircularRegular',
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            }
        },
        '& p': {
            margin: '0',
            fontSsize: '0.75rem',
            marginTop: '3px',
            textAlign: 'left',
            fontFamily: 'CircularRegular',
            fontWeight: '400',
            lineHeight: '1.66',
            letterSpacing: '0.03333em'
        },
    },
    select: {
        // reseting default styles
        // width: '100%',
        // fontSsize: '0.75rem',
        // lineHeight: '1.66',
        // letterSpacing: '0.03333em',
        // fontFamily: 'CircularRegular',
        // //overriding
        // padding: '0 5px',
        // height: '30px',
        // boxSizing: 'border-box',
        // border: '1px solid rgb(232, 232, 232)',
        borderRadius: '6px',
        backgroundColor: 'rgb(243, 243, 243)'
    },
    textArea: {
        maxWidth: '100%',
        resize: 'vertical',
        '& label': {
            display: 'block',
            marginBottom: '8px'
        },
        '& textarea': {
            minHeight: '96px',
            padding: '10px 12px',
            boxSizing: 'border-box',
            border: '1px solid rgb(232, 232, 232)',
            borderRadius: '6px',
            backgroundColor: 'rgb(243, 243, 243)',
            minWidth: '100%',
            width: '100%',
            maxWidth: '100%',
            '&::after': {
                content: 'none !important'
            },
            resize: 'vertical',
            wrap: 'soft'
        },
        '& > p': {
            margin: '0',
            fontSsize: '0.75rem',
            marginTop: '3px',
            textAlign: 'left',
            fontFamily: 'CircularRegular',
            fontWeight: '400',
            lineHeight: '1.66',
            letterSpacing: '0.03333em'
        }
    },
    applicationInput: {
        '& input': {
            padding: '0 16px',
            height: '40px',
            border: '1px solid #E7ECEF',
            borderRadius: '8px',
            backgroundColor: '#E7ECEF'
        }
    },
    applicationTextArea: {
        '& textarea': {
            padding: '12px 16px',
            border: '1px solid #E7ECEF',
            borderRadius: '8px',
            backgroundColor: '#E7ECEF'
        }
    },
    redioButtonsField: {
        '& label': {
            fontSize: '10px',
            fontWeight: '600',
            color: '#E2EBFD'
        },
        '& > span': {
            margin: '0',
            fontSsize: '0.75rem',
            marginTop: '3px',
            textAlign: 'left',
            fontFamily: 'CircularRegular',
            fontWeight: '400',
            lineHeight: '1.66',
            letterSpacing: '0.03333em'
        }
    },
    error: {
        display: 'block',
        fontSize: '11px',
        color: 'red',
        fontFamily: 'CircularRegular',
        fontWeight: '400',
        letterSpacing: '0.03333em',
    },
    labelRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        paddingBottom: '0.4rem',
        '& label': {
            paddingBottom: 0,
            marginBottom: 0,
        },
    },
    uploadError: {
        display: 'block',
        fontSize: '11px',
        color: 'red',
        fontFamily: 'CircularRegular',
        marginTop: '0.5rem',
        lineHeight: '1.5'
    },
    noOptionsMessage: {
        fontSize: 16,
        display: 'flex',
        justifyContent: 'center'
    },
    fileUploadButton: {
        //paddingTop: '0.5rem',
        display: 'flex',
        marginTop: '1px',
        marginBottom: '1px',
        // marginLeft: '-5px',
        // marginRight: '-5px',
        fontFamily: 'CircularRegular',
        fontSize: '12px',
        lineHeight: '30px',
        borderRadius: '6px',
        backgroundColor: 'rgb(243, 243, 243)',
        flexWrap: 'wrap',
        color: 'darkgray',
        flex: '1 0 auto',
        alignItems: 'center',
        justifyContent: 'center',
        //width: '25%',
        //margin: '5px',
        padding: '4px 8px',
        boxSizing: 'border-box',
        textAlign: 'center',
        cursor: 'pointer',
        boxShadow: 'none',
        border: 'none',
        width: '100%'
    },
    saveCropButton: {
        display: 'flex',
        marginTop: '1px',
        marginBottom: '1px',
        fontFamily: 'CircularRegular',
        fontWeight: 'bold',
        fontSize: '0.875rem',
        lineHeight: '30px',
        borderRadius: '6px',
        backgroundColor: '#94004A',
        flexWrap: 'wrap',
        color: 'white',
        flex: '1 0 auto',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 8px',
        boxSizing: 'border-box',
        textAlign: 'center',
        cursor: 'pointer',
        boxShadow: 'none',
        border: 'none',
        width: '100%'
    },
    imageContainer: {
        marginTop: '1rem',
        maxWidth: 500, // Adjust as needed 
        // maxHeight: 400,
        //overflow: 'hidden'
    }
});
const selectStyles: StylesConfig<any> = {
    option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => {
        return {
            ...styles,
            backgroundColor: isDisabled
                ? undefined
                : isSelected
                    ? 'rgb(231, 236, 239)'
                    : isFocused
                        ? 'rgb(231, 236, 239)'
                        : undefined,
            cursor: isDisabled ? 'not-allowed' : 'default',
            color: '#000'
        };
    },
    input: (styles: any) => ({
        ...styles,
        fontFamily: 'CircularRegular'
    }),
    valueContainer: (styles: any) => ({
        ...styles,
        fontFamily: 'CircularRegular'
    })
};
export const MyRadio: FC<any> = ({ input, meta, items, ...props }) => {
    const styles = useStyles();
    const showError = meta.submitFailed && meta.error;
    return (<div className={styles.redioButtonsField}>
      {props.label && (<div className={styles.labelRow}>
        {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      </div>)}
      {props.notice && props.notice}
      <div className={styles.applicationRadios}>
        {items.map(([key, title]: [
            string,
            string
        ]) => (<div onClick={() => {
                input.onChange(key);
                input.onBlur();
                if (typeof props.extraChange === 'function') {
                    props.extraChange(key);
                }
            }} key={key} style={props.style || {}} className={(key === input.value && 'active') || ''}>
            {title}
          </div>))}
      </div>
      <FieldErrorTooltip error={meta.error} visible={showError} />
    </div>);
};
export const MyApartmentRadio: FC<any> = ({ input, meta, items, ...props }) => {
    const styles = useStyles();
    const showError = meta.submitFailed && meta.error;
    return (<div className={styles.redioButtonsField}>
      {props.label && (<div className={styles.labelRow}>
        {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      </div>)}
      <div className={styles.AppsRadios}>
        {items.map(([key, title]: [
            string,
            string
        ]) => (<div onClick={() => {
                input.onChange(key);
                input.onBlur();
                if (typeof props.extraChange === 'function') {
                    props.extraChange(key);
                }
            }} key={key} style={props.style || {}} className={(key === input.value && 'active') || ''}>
            {title}
          </div>))}
      </div>
      <FieldErrorTooltip error={meta.error} visible={showError} />
    </div>);
};
const loadGoogleMaps = (() => {
    let loaded = false;
    return () => {
        if (loaded || typeof window === 'undefined') return;
        if (!document.querySelector('#google-maps')) {
            const script = document.createElement('script');
            script.setAttribute('async', '');
            script.setAttribute('defer', '');
            script.setAttribute('id', 'google-maps');
            script.src = getPlacesApiUrl();
            document.querySelector('head')?.appendChild(script);
        }
        loaded = true;
    };
})();

export const MyTagInput: FC<any> = ({ input, meta, placeholder, label }) => {
    const styles = useStyles();
    const [inputValue, setInputValue] = useState('');
    const [suggestions, setSuggestions] = useState<string[]>([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const tags: string[] = Array.isArray(input.value) ? input.value : [];
    const showError = meta.submitFailed && meta.error;

    loadGoogleMaps();

    const fetchSuggestions = useMemo(() => throttle((query: string, callback: (results: string[]) => void) => {
        if (!(window as any).google?.maps?.places?.AutocompleteService) {
            callback([]);
            return;
        }
        const service = new (window as any).google.maps.places.AutocompleteService();
        service.getPlacePredictions({
            input: query,
            componentRestrictions: { country: ['fi', 'ax'] }
        }, (results: any[] | null, status: any) => {
            const OK = (window as any).google.maps.places.PlacesServiceStatus.OK;
            if (status === OK && results) {
                callback(results.map((r: any) => {
                    const desc = r.description || '';
                    const parts = desc.split(',').map((p: string) => p.trim()).filter((p: string) => !/^(Finland|Suomi)$/i.test(p));
                    return parts.join(', ');
                }));
            } else {
                callback([]);
            }
        });
    }, 300), []);

    useEffect(() => {
        if (!inputValue.trim()) {
            setSuggestions([]);
            return;
        }
        fetchSuggestions(inputValue, (results) => {
            setSuggestions(results.filter(r => !tags.includes(r)));
            setShowSuggestions(results.length > 0);
        });
    }, [inputValue]);

    const addTag = (raw: string) => {
        const trimmed = raw.trim();
        if (trimmed && !tags.includes(trimmed)) {
            input.onChange([...tags, trimmed]);
        }
        setInputValue('');
        setSuggestions([]);
        setShowSuggestions(false);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
            e.preventDefault();
            addTag(inputValue);
        } else if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
            input.onChange(tags.slice(0, -1));
        } else if (e.key === 'Escape') {
            setShowSuggestions(false);
        }
    };

    const removeTag = (tag: string) => {
        input.onChange(tags.filter(t => t !== tag));
    };

    return (
        <div className={styles.redioButtonsField} style={{ position: 'relative' }}>
            {label && <div className={styles.labelRow}><FormLabel>{label}</FormLabel></div>}
            <div className={styles.tagInput} onClick={() => inputRef.current?.focus()}>
                {tags.map(tag => (
                    <span key={tag} className={styles.tag}>
                        {tag}
                        <button type='button' onClick={() => removeTag(tag)}>×</button>
                    </span>
                ))}
                <input
                    ref={inputRef}
                    value={inputValue}
                    onChange={e => { setInputValue(e.target.value); setShowSuggestions(true); }}
                    onKeyDown={handleKeyDown}
                    onBlur={() => {
                        setTimeout(() => {
                            setShowSuggestions(false);
                            if (inputValue) addTag(inputValue);
                            input.onBlur();
                        }, 150);
                    }}
                    placeholder={tags.length === 0 ? placeholder : ''}
                />
            </div>
            {showSuggestions && suggestions.length > 0 && (
                <div className={styles.tagSuggestions}>
                    {suggestions.map(s => (
                        <div
                            key={s}
                            className={styles.tagSuggestionItem}
                            onMouseDown={e => { e.preventDefault(); addTag(s); }}
                        >
                            {s}
                        </div>
                    ))}
                </div>
            )}
            <FieldErrorTooltip error={meta.error} visible={showError} />
        </div>
    );
};
export const MyApartmentCheckboxes: FC<any> = ({ input, meta, items, ...props }) => {
    const styles = useStyles();
    const showError = meta.submitFailed && meta.error;
    const selected: string[] = Array.isArray(input.value) ? input.value : [];
    const toggle = (key: string) => {
        const next = selected.includes(key) ? selected.filter(k => k !== key) : [...selected, key];
        input.onChange(next);
        input.onBlur();
    };
    return (<div className={styles.redioButtonsField}>
      {props.label && (<div className={styles.labelRow}>
        <FormLabel>{props.label}</FormLabel>
      </div>)}
      <div className={styles.AppsRadios}>
        {items.map(([key, title]: [string, string]) => (
          <div onClick={() => toggle(key)} key={key} style={props.style || {}} className={selected.includes(key) ? 'active' : ''}>
            {title}
          </div>
        ))}
      </div>
      <FieldErrorTooltip error={meta.error} visible={showError} />
    </div>);
};
export const MyCheckboxes: FC<any> = ({ input, meta, items, ...props }) => {
    const styles = useStyles();
    const showError = meta.submitFailed && meta.error;
    return (<>
      {props.label && (<div className={styles.labelRow}>
        {props.label && (<FormLabel>{props.label}</FormLabel>)}
      </div>)}
      {props.notice && props.notice}
      <div className={styles.applicationRadios}>
        {items.map(([key, title]: [
            string,
            string
        ]) => (<div onClick={() => {
                const newNalue = new Set(Array.isArray(input.value) ? input.value : []);
                if (newNalue.has(key)) {
                    newNalue.delete(key);
                }
                else {
                    newNalue.add(key);
                }
                input.onChange([...newNalue]);
            }} key={key} className={(Array.isArray(input.value) &&
                input.value.includes(key) &&
                'active') ||
                ''}>
            {title}
          </div>))}
      </div>
      <FieldErrorTooltip error={meta.error} visible={showError} />
    </>);
};
export const MyInput: FC<any> = ({ input, meta, items, preventSpaces, InputIcon, helperText, InputProps, fullWidth, inputProps: nativeInputProps, validate, normalize, select, ...props }) => {
    const styles = useStyles();
    const { onKeyDown: onKeyDownProp, onChange: onChangeProp, applicationStyle, wrapperStyle, ...restProps } = props;
    // Extract valid HTML attrs from MUI-style InputProps (min/step/max); ignore endAdornment etc.
    const inputPropsFromInputProps = InputProps
        ? { min: InputProps.min, step: InputProps.step, max: InputProps.max }
        : {};
    const shouldShowError = meta.submitFailed && meta.error;
    const wrapperClassName = applicationStyle
        ? `${styles.input} ${styles.applicationInput}`
        : styles.input;
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (preventSpaces && event.key === ' ') {
            event.preventDefault();
            return;
        }
        if (typeof onKeyDownProp === 'function') {
            onKeyDownProp(event);
        }
    };
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        input.onChange(event);
        if (typeof onChangeProp === 'function') {
            onChangeProp(event);
        }
    };
    return (<div className={wrapperClassName} style={props.wrapperStyle}>
      {props.label && (<div className={styles.labelRow}>
        {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      </div>)}
      <input id={`field-${input.name}`} onChange={handleChange} type={props.type} placeholder={props.placeholder} style={props.style} onBlur={input.onBlur} onKeyDown={handleKeyDown} value={typeof input.value !== 'object' ? (input.value ?? '') : input.value.label} disabled={props.disabled} {...inputPropsFromInputProps} {...(nativeInputProps || {})} {...restProps}/>
      {InputIcon && (<p className={styles.inputIcon}>{InputIcon}</p>)}
      {helperText && (<p className={styles.helperText}>{helperText}</p>)}
      <FieldErrorTooltip error={meta.error} visible={shouldShowError} />
    </div>);
};
export const MySelect: FC<any> = ({ input, children, meta, items, ...props }) => {
    const styles = useStyles();
    const showError = meta.submitFailed && meta.error;
    return (<div className={styles.input}>
      {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      <select id={`field-${input.name}`} className={styles.select} onChange={input.onChange} style={props.style} onBlur={input.onBlur} value={input.value} disabled={props.disabled}>
        <option value='' disabled hidden></option>
        {children.map((el: any, i: number) => {
            return (<option value={el?.props?.value} key={i}>
              {el?.props?.children}
            </option>);
        })}
      </select>
      {props?.helperText && (<p className={styles.helperText}>{props.helperText}</p>)}
      <FieldErrorTooltip error={meta.error} visible={showError} />
    </div>);
};
export const MySelectWithInput: FC<any> = ({ input, children, meta, items, ...props }) => {
    const styles = useStyles();
    return (<div className={styles.input}>
      {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      <input list={`field-${input.name}`} onChange={input.onChange} className={styles.select} style={props.style} value={input.value} onBlur={input.onBlur}/>
      <datalist id={`field-${input.name}`}>
        <option value='' disabled hidden></option>
        {children.map((el: any, i: number) => {
            return (<option value={el?.props?.value} key={i}>
              {el?.props?.children}
            </option>);
        })}
      </datalist>
      {props?.helperText && (<p className={styles.helperText}>{props.helperText}</p>)}
      <FieldErrorTooltip error={meta.error} visible={meta.submitFailed && meta.error} />
    </div>);
};
const NoOptionsMessage: FC<any> = ({ selectProps, innerProps, children, ...props }) => {
    const styles = useStyles();
    return (<Typography variant='body1' className={styles.noOptionsMessage} {...innerProps}>
      {children}
    </Typography>);
};
const Option: FC<any> = ({ innerRef, isFocused, isSelected, innerProps, children, ...props }) => {
    return (<MenuItem ref={innerRef} selected={isFocused} component='div' style={{
            fontWeight: isSelected ? 500 : 400
        }} {...innerProps}>
      {children}
    </MenuItem>);
};
const IndicatorSeparator: FC<any> = () => null;
export const ReduxFormSelect: FC<any> = ({ input, children, meta, items, options, ...props }) => {
    const styles = useStyles();
    const components = {
        IndicatorSeparator,
        NoOptionsMessage,
        Option
    };
    return (<div className={styles.input}>
      {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      <Select {...input}
    // Ensure controlled component with empty initial value
    value={input.value ?? null} defaultValue={null} onChange={(event) => {
            input.onChange(event);
        }} onBlur={(event) => {
            event.preventDefault();
        }} options={options}
    // Do not auto-select the first option; start blank
    isSearchable isClearable={props.isClearable ?? false} styles={{
            ...selectStyles,
            control: (baseStyles) => ({
                ...baseStyles,
                backgroundColor: props.backgroundColor
                    ? props.backgroundColor
                    : '#E7ECEF',
                border: 'none',
                height: '58px'
            })
        }} placeholder={props.placeholder || ''} components={components} classNamePrefix='react-select'/>
      <FieldErrorTooltip error={meta.error} visible={meta.submitFailed && !!meta.error} />
    </div>);
};
export const MyTextArea: FC<any> = ({ input, meta, items, ...props }) => {
    const styles = useStyles();
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    useEffect(() => {
        if (props.applicationStyle && textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
        }
    }, [input.value, props.applicationStyle]);
    const wrapperClassName = props.applicationStyle
        ? `${styles.textArea} ${styles.applicationTextArea}`
        : styles.textArea;
    const textareaStyle = props.applicationStyle
        ? { resize: 'none' as const, overflow: 'hidden', ...props.style }
        : props.style;
    return (<div className={wrapperClassName}>
      {props.label && (<div className={styles.labelRow}>
        {props.label && (<FormLabel htmlFor={`field-${input.name}`}>{props.label}</FormLabel>)}
      </div>)}
      <textarea ref={textareaRef} id={`field-${input.name}`} className={styles.input} onChange={input.onChange} placeholder={props.placeholder} style={textareaStyle} onBlur={input.onBlur} value={input.value ?? ''} disabled={props.disabled}/>
      <FieldErrorTooltip error={meta.error} visible={meta.submitFailed && meta.error} />
    </div>);
};
export const ImageUploadButton: FC<any> = ({ input, uploadText, changeText, uploadErrorText, meta }) => {
    const styles = useStyles();
    const [previewUrl, setPreviewUrl] = useState<string | null>(
        typeof input.value === 'string' && input.value ? input.value : null
    );
    const inputId = `image-upload-${input.name}`;
    const [uploadError, setUploadError] = useState(false);

    const resizeAndCenterCrop = (imageSrc: string): Promise<Blob> => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const size = 500;
                const canvas = document.createElement('canvas');
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    reject(new Error('Unable to get canvas context'));
                    return;
                }
                // Center-crop: take the largest centered square from the source
                const srcSize = Math.min(image.naturalWidth, image.naturalHeight);
                const sx = (image.naturalWidth - srcSize) / 2;
                const sy = (image.naturalHeight - srcSize) / 2;
                ctx.drawImage(image, sx, sy, srcSize, srcSize, 0, 0, size, size);
                canvas.toBlob(
                    (blob) => blob ? resolve(blob) : reject(new Error('Canvas toBlob failed')),
                    'image/jpeg',
                    0.9
                );
            };
            image.onerror = () => reject(new Error('Image loading failed'));
            image.src = imageSrc;
        });
    };

    const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        if (!file) {
            setPreviewUrl(null);
            return;
        }
        const reader = new FileReader();
        reader.onload = async () => {
            const dataUrl = reader.result as string;
            const image = new Image();
            image.onload = async () => {
                if (image.width < 200 || image.height < 200) {
                    setPreviewUrl(null);
                    setUploadError(true);
                    return;
                }
                setUploadError(false);
                try {
                    const blob = await resizeAndCenterCrop(dataUrl);
                    setPreviewUrl(URL.createObjectURL(blob));
                    input.onChange(blob);
                } catch {
                    setUploadError(true);
                }
            };
            image.src = dataUrl;
        };
        reader.readAsDataURL(file);
    };

    return (<div>
      <label htmlFor={inputId} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            minHeight: 180,
            borderRadius: 12,
            backgroundColor: '#f6f8fb',
            border: '2px dashed #d0d5dd',
            cursor: 'pointer',
            padding: '24px 16px'
        }}
      >
        {previewUrl ? (
            <img src={previewUrl} alt="Profile" style={{
                width: 140,
                height: 140,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '3px solid #f0f0f0'
            }}/>
        ) : (
            <img src={uploadImageWatermark} alt="" style={{ width: 72, opacity: 0.7 }}/>
        )}
        <input id={inputId} type="file" accept="image/*" onChange={handleFileSelect} style={{ display: 'none' }}/>
        <span style={{ fontSize: 13, fontWeight: 500, color: '#5f6c85' }}>
          {previewUrl ? changeText : uploadText}
        </span>
      </label>
      {uploadError && (<span className={styles.uploadError}>{uploadErrorText}</span>)}
      <FieldErrorTooltip error={meta.error} visible={meta.submitFailed && meta.error} />
    </div>);
};
